import http from '@/utils/http';

export default {
	login: data => {
		return http({ url: '/api/admin/v1/user/login', data,loading:true }).then(r => r);
	},
	changePassword: data => {
		return http({ url: '/api/admin/v1/user/updatePassword', data, tip: true,loading:true }).then(r => r);
	},
	save: data => {
		return http({url:'/api/admin/v1/user/save',data,tip:true,loading:true}).then(r => r)
	},
	updateAppStatus: data => {
		return http({url:'/api/admin/v1/user/updateStatus',data,tip:true,loading:true}).then(r => r)
	},
	updateUserType: data => {
		return http({url:'/api/admin/v1/user/updateUserType',data,tip:true,loading:true}).then(r => r)
	},
	delete: data => {
		return http({url:'/api/admin/v1/user/delete',data,tip:true,loading:true}).then(r => r)
	},
	list: data => {
		return http({url:'/api/admin/v1/user/list',data}).then(r => r)
	},
	listAll: () => {
		return http({url:'/api/admin/v1/user/listAll'}).then(r => r)
	},
};
